<template>
    <!-- v-card -->
      <!-- v-card-text class="pr-4 pl-4 pt-2 pb-2" -->
      <div  class="mt-1 pb-3">
          <v-row no-gutters style="-webkit-box-align: center; align-items: center;">
              <v-col cols="12">
                <v-breadcrumbs class="pa-1 ma-1 ml-3 ml-md-2" :items="breadcrumbs" divider="/" ></v-breadcrumbs>
              </v-col>
          </v-row>
          <v-divider></v-divider>
        </div>
        
        

        <!-- /v-card-text -->
      <!-- /v-card -->
</template>

<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
    i18n,
    props: ['backurl','breadcrumbs'],
}
</script>  